import environment from "../environment";
import { GET, GETWithParams, PATCH, POST } from "./http.service";

const _endpoint = environment.COURSES_ENDPOINT;
const _token = environment.TOKEN_KEY;

export const getAllCourses = async (requestBody) => {
  const response = await POST(
    `Course/search`,
    requestBody,
    localStorage.getItem(_token) || false
  );
  return response;
};

export const getFeaturesCourses = async () => {
  const response = await GET(`Course/home-list`, localStorage.getItem(_token));
  return response;
};

export const getCourseMainDetails = async (slug) => {
  const response = await GET(`Course/${slug}`, localStorage.getItem(_token));
  return response;
};

export const getAllRecordedCourseLessons = async (slug) => {
  const response = await GET(
    `CourseRecordedSession/student/course/${slug}`,
    localStorage.getItem(_token)
  );
  return response;
};

export const checkWatchStatus = async (slug) => {
  const response = await PATCH(
    `CourseRecordedSession/${slug}/watch-status`,
    null,
    localStorage.getItem(_token)
  );
  return response;
};

export const getCourseSchedule = async (slug) => {
  const response = await GET(
    `CourseSchedule/${slug}`,
    localStorage.getItem(_token)
  );
  return response;
};

export const getCourseStudentOpinions = async (requestParams) => {
  const response = await GETWithParams(`Review`, requestParams, false);
  return response;
};

export const getAllLessons = async (id) => {
  const response = await GET(
    `CourseSession/student/course/${id}`,
    localStorage.getItem(_token)
  );
  return response;
};

export const getPublishKey = async () => {
  const response = await GET(`Payment/config`, localStorage.getItem(_token));
  return response;
};

export const getClientSecret = async (requestBody) => {
  const response = await POST(
    `CourseRegistration/process`,
    requestBody,
    localStorage.getItem(_token)
  );
  return response;
};

export const checkCoupon = async (requestBody) => {
  const response = await POST(
    `Coupon/check`,
    requestBody,
    localStorage.getItem(_token)
  );
  return response;
};
